export const initialSizePerPage = 10;

export const pageSizeOptions = [10, 25, 50, 100, 250, 500];
